/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advantages_Sample_Citation_1Inputs */

const en_advantages_sample_citation_1 = /** @type {(inputs: Advantages_Sample_Citation_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Baevski at al, 2020)`)
};

const es_advantages_sample_citation_1 = /** @type {(inputs: Advantages_Sample_Citation_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Baevski et al, 2020)`)
};

/**
* | output |
* | --- |
* | "(Baevski at al, 2020)" |
*
* @param {Advantages_Sample_Citation_1Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const advantages_sample_citation_1 = /** @type {((inputs?: Advantages_Sample_Citation_1Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advantages_Sample_Citation_1Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_advantages_sample_citation_1(inputs)
	return en_advantages_sample_citation_1(inputs)
});